export default "__VITE_ASSET__BOtjBgTy__"